/* eslint-disable */
/// This file is auto generated - do not edit manually
export const TopicSelectButton = 'Website.ArticleUniverse.Filter.TopicSelectButton';
export const SectionSelectButton = 'Website.ArticleUniverse.Filter.SectionSelectButton';
export const OpenFilterDrawer = 'Website.ArticleUniverse.Filter.OpenFilterDrawer';
